import $ from "jquery";

export function handleNav() {
    $('body').on('click', '.js-toggle-nav', function () {
        $('body').toggleClass('mobile-menu-active');
        return false;
    }).on('click', '.js-toggle-nav-dropdown', function () {
        if ($(window).outerWidth() >= 960) {
            return true;
        }

        $(this).closest('.nav__item').toggleClass('nav__item--dropdown-active');
        return false;
    });
}

export function handleStickyNav() {
    $(window).on("scroll load", function () {
        if ($(this).scrollTop() > 0) {
            $("header").addClass("header--sticky");
        } else {
            $("header").removeClass("header--sticky");
        }
    });
}